import React from 'react';
import { RowActionsRender, TableColumn, TableRowData } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// components
import GenericTable from 'components/Table/GenericTable';
import CommonIcon from 'components/CommonIcon';
import { Wrapper } from 'pages/MerchantPages/Assets/Price/components/PricesTable';
import { ErrorFile } from 'ducks/merchantDucks/vouchers/types';
import { convertArrayToCamelCase } from 'utils/helpers';

const ErrorsWrapper = styled(Wrapper)<{ isAdmin: boolean }>`
  ${({ isAdmin }) => isAdmin && 'padding-bottom: 2rem'};
`;

interface Props {
  collection: Array<ErrorFile>;
  downloadFile: (filename: string) => void;
  isFetchingErrorFiles: boolean;
  isAdmin: boolean;
}

interface BulkErrorsTableData extends TableRowData {
  name: string;
  createdAt: string;
}

const BulkErrorsTable: React.FC<Props> = ({ collection, downloadFile, isFetchingErrorFiles, isAdmin }) => {
  const errorsCollection = convertArrayToCamelCase<ErrorFile, BulkErrorsTableData>(collection);

  const generateColumns = (): Array<TableColumn<BulkErrorsTableData>> => [
    {
      title: 'Name',
      key: 'name',
    },
    {
      title: 'Created at (UTC)',
      key: 'createdAt',
      render: ({ rowValues }) => {
        const { createdAt } = rowValues;
        return <>{createdAt}</>;
      },
    },
  ];

  const renderRowActions: RowActionsRender<BulkErrorsTableData> = ({ row }) => {
    const { name } = row;
    return (
      <span>
        <CommonIcon hoverStatus="download" name="download" onClick={() => downloadFile(name)} />
      </span>
    );
  };

  return (
    <ErrorsWrapper isAdmin={isAdmin}>
      <GenericTable<BulkErrorsTableData>
        columns={generateColumns()}
        data={errorsCollection}
        showLoader={isFetchingErrorFiles}
        options={{
          rowActions: renderRowActions,
        }}
        actionsRowTitle="Download"
      />
    </ErrorsWrapper>
  );
};

export default BulkErrorsTable;
